var _circle, _circle2, _circle3, _circle4, _g, _g2, _line, _circle5, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRealestate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9811,
    cy: 51.9811,
    r: 51.9811,
    fill: "#314DD8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9811,
    cy: 51.9811,
    r: 51.9811,
    fill: "#060C23"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.069,
    cy: 39.2419,
    r: 33.3478,
    fill: "#2E293D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_248_28843",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 104,
    height: 104
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.9811,
    cy: 51.9811,
    r: 51.9811,
    fill: "#060C23"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_248_28843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.5509 34.6668H30.7246V103.972H73.5509V34.6668Z",
    fill: "#314DD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2178 39.9626H35.9282V48.2521H44.2178V39.9626Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9282 48.2521C35.9282 48.2521 37.6782 41.4823 44.2178 39.9626H35.9282V48.2521Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3481 39.9626H60.0586V48.2522H68.3481V39.9626Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0586 48.2522C60.0586 48.2522 61.8086 41.4824 68.3481 39.9626H60.0586V48.2522Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2182 51.9825H35.9287V60.2721H44.2182V51.9825Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9282 60.3191C35.9282 60.3191 37.6782 53.5493 44.2178 52.0295H35.9282V60.3191Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3481 51.9817H60.0586V60.2712H68.3481V51.9817Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0581 60.3183C60.0581 60.3183 61.8081 53.5486 68.3476 52.0288H60.0581V60.3183Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2837 64.0465H47.9941V72.336H56.2837V64.0465Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9941 72.383C47.9941 72.383 49.7442 65.6133 56.2837 64.0935H47.9941V72.383Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2182 64.0466H35.9287V72.3362H44.2182V64.0466Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9282 72.3832C35.9282 72.3832 37.6782 65.6134 44.2178 64.0936H35.9282V72.3832Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3481 64.0465H60.0586V72.336H68.3481V64.0465Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0581 72.383C60.0581 72.383 61.8081 65.6133 68.3476 64.0935H60.0581V72.383Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2837 76.1117H47.9941V84.4012H56.2837V76.1117Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9941 84.4012C47.9941 84.4012 49.7442 77.6314 56.2837 76.1117H47.9941V84.4012Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2178 76.1116H35.9282V84.4012H44.2178V76.1116Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9282 84.4012C35.9282 84.4012 37.6782 77.6314 44.2178 76.1116H35.9282V84.4012Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3476 76.1117H60.0581V84.4012H68.3476V76.1117Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0581 84.4012C60.0581 84.4012 61.8081 77.6314 68.3476 76.1117H60.0581V84.4012Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9513 57.7838H73.5508V103.972H86.9513V57.7838Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5508 103.972H76.9124C76.9124 103.972 75.3007 71.829 73.5508 57.7838V103.972Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4511 62.3423H77.0967V68.6968H83.4511V62.3423Z",
    fill: "#152B9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0962 68.7438C77.0962 68.7438 77.1422 63.0801 83.4506 62.3894H77.0962V68.7438Z",
    fill: "#152B9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4511 72.5655H77.0967V78.9199H83.4511V72.5655Z",
    fill: "#152B9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0962 78.967C77.0962 78.967 77.1422 73.3032 83.4506 72.6125H77.0962V78.967Z",
    fill: "#152B9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4511 82.7885H77.0967V89.1429H83.4511V82.7885Z",
    fill: "#152B9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0962 89.1899C77.0962 89.1899 77.1422 83.5262 83.4506 82.8355H77.0962V89.1899Z",
    fill: "#152B9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4511 93.0117H77.0967V99.3662H83.4511V93.0117Z",
    fill: "#152B9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0962 99.4131C77.0962 99.4131 77.1422 93.7494 83.4506 93.0587H77.0962V99.4131Z",
    fill: "#152B9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3334 103.959H30.7339L30.7339 57.7707H17.3334L17.3334 103.959Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7249 103.972H27.3633C27.3633 103.972 28.975 71.829 30.7249 57.7838V103.972Z",
    fill: "#243CBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1787 62.3425H20.8242V68.697H27.1787V62.3425Z",
    fill: "#152B9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8237 68.7439C20.8237 68.7439 20.8698 63.0802 27.1782 62.3895H20.8237V68.7439Z",
    fill: "#152B9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1787 72.5656H20.8242V78.92H27.1787V72.5656Z",
    fill: "#152B9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8237 78.9669C20.8237 78.9669 20.8698 73.3032 27.1782 72.6125H20.8237V78.9669Z",
    fill: "#152B9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1787 82.7888H20.8242V89.1432H27.1787V82.7888Z",
    fill: "#152B9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8237 89.1902C20.8237 89.1902 20.8698 83.5265 27.1782 82.8358H20.8237V89.1902Z",
    fill: "#152B9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1787 93.0118H20.8242V99.3662H27.1787V93.0118Z",
    fill: "#152B9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8237 99.4133C20.8237 99.4133 20.8698 93.7495 27.1782 93.0588H20.8237V99.4133Z",
    fill: "#152B9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3955 89.7869H42.6401V104.108H62.3955V89.7869Z",
    fill: "#435CDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2637 104.114V91.9105H44.7449V104.114H60.2637Z",
    fill: "#22FFAA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_248_28843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5936 37.1894C50.7618 37.1894 48.9817 36.8282 47.3305 36.1316L47.3305 59.0158C47.3305 59.1964 47.395 59.3899 47.524 59.5189L52.0131 64.6272C52.155 64.7949 52.3743 64.8852 52.5936 64.8981C52.8 64.8981 52.9935 64.8078 53.1354 64.6659C53.1483 64.653 53.1612 64.6401 53.1741 64.6272L57.6632 59.5447C57.7793 59.4028 57.8567 59.2222 57.8567 59.0416L57.8438 55.4942C57.8438 55.3136 57.7793 55.1201 57.6374 54.9782L55.122 52.1531L57.6374 49.3281C57.8954 49.0443 57.8954 48.6057 57.6503 48.309L55.4961 45.7161L57.6632 43.1878C57.7793 43.0459 57.8438 42.8782 57.8567 42.6847V36.1058C56.2314 36.8024 54.4641 37.1765 52.5936 37.1894Z",
    fill: "#22FFAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5934 10.478C45.1115 10.478 39.0099 16.5796 39.0099 24.0615C39.0099 27.6734 40.416 31.0919 42.9831 33.6589C45.5501 36.226 48.9557 37.645 52.5805 37.6321C56.3215 37.6321 59.727 36.1099 62.178 33.6589C64.6418 31.1951 66.1511 27.8024 66.1511 24.0615C66.1769 16.5538 60.0882 10.4651 52.5934 10.478Z",
    fill: "#22FFAA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.697,
    cy: 23.9217,
    r: 5.89374,
    fill: "white"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 52.6968,
    y1: 27.3887,
    x2: 52.6968,
    y2: 91.8731,
    stroke: "white",
    strokeWidth: 1.38676
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.6937,
    cy: 92.2139,
    r: 1.73369,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.20361 56.3339C4.62438 49.5956 5.5323 43.0725 7.65479 37.0885M9.98039 31.6694C10.8977 29.8627 11.9318 28.1221 13.0738 26.4585C13.9228 25.2217 14.8314 24.0275 15.7958 22.8802",
    stroke: "white",
    strokeWidth: 2.08014,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6697 70.8282C94.6662 68.8549 95.5175 66.8151 96.2189 64.7267C97.4487 61.0645 98.2171 57.2526 98.4979 53.3863",
    stroke: "white",
    strokeWidth: 2.08014,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_248_28843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.9989,
    height: 42.9989,
    fill: "white",
    transform: "translate(22.1885 35.2586) rotate(-45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealestate);
export default __webpack_public_path__ + "static/media/real estate.96152820ba09c08a1360827ff00f6f43.svg";
export { ForwardRef as ReactComponent };